/******************************************************************
 * Write page logic js here
 *****************************************************************/
var TmplData = require('./mustache-tmpl.js');
var Common = require('./common.js');

/*
 * Search panel logic on Accounts Overview page,
 */
$(function () {
    $('.transactions-advanced-search-btn').on('click', function () {
        if ($(this).attr('aria-expanded') === 'true') {
            $('#search_collapse_panel').collapse('hide');
            $(this).removeAttr('aria-expanded');
        } else {
            $('#search_collapse_panel').collapse('show');
            $(this).attr('aria-expanded', 'true');
            $('.transactions-qucik-search-btn').removeAttr('aria-expanded');
            $('.corporate-files-search-btn').removeAttr('aria-expanded');
        }

        $('.transaction-search-panel-quick').removeClass('d-none');
        $('.transaction-search-panel-desc-advanced').removeClass('d-none');
        $('.transaction-search-panel-desc-quick').addClass('d-none');
        $('.transaction-search-panel-advanced').removeClass('d-none');
        $('.corporate-file-search-btn').addClass('d-none');
        $('.transaction-search-btn').removeClass('d-none');
        $('.corporate-file-search-panel').addClass('d-none');
        $('.corporate-file-search-panel-desc').addClass('d-none');
    });

    $('.transactions-qucik-search-btn').on('click', function () {
        if ($(this).attr('aria-expanded') === 'true') {
            $('#search_collapse_panel').collapse('hide');
            $(this).removeAttr('aria-expanded');
        } else {
            $('#search_collapse_panel').collapse('show');
            $(this).attr('aria-expanded', 'true');
            $('.transactions-advanced-search-btn').removeAttr('aria-expanded');
        }
        $('.transaction-search-panel-quick').removeClass('d-none');
        $('.transaction-search-panel-desc-quick').removeClass('d-none');
        $('.transaction-search-panel-desc-advanced').addClass('d-none');
        $('.transaction-search-panel-advanced').addClass('d-none');
    });

    $('.corporate-files-search-btn').on('click', function () {
        if ($(this).attr('aria-expanded') === 'true') {
            $('#search_collapse_panel').collapse('hide');
            $(this).removeAttr('aria-expanded');
        } else {
            $('#search_collapse_panel').collapse('show');
            $(this).attr('aria-expanded', 'true');
            $('.transactions-advanced-search-btn').removeAttr('aria-expanded');
        }
        $('.transaction-search-panel-quick').addClass('d-none');
        $('.transaction-search-panel-desc-quick').addClass('d-none');
        $('.transaction-search-panel-desc-advanced').addClass('d-none');
        $('.transaction-search-panel-advanced').addClass('d-none');
        $('.corporate-file-search-btn').removeClass('d-none');
        $('.transaction-search-btn').addClass('d-none');
        $('.corporate-file-search-panel').removeClass('d-none');
        $('.corporate-file-search-panel-desc').removeClass('d-none');
    });

    $('.corporate-file-search-btn').on('click', function () {
        if (!$('.corporate-file-date-from').val() == "" && !$('.corporate-file-date-to').val() == "") {
            $('.corporate-file-table').removeClass('d-none');
            $('.transaction-table').addClass('d-none');
        }
    });

    $('.transaction-search-btn').on('click', function () {
        $('.corporate-file-table').addClass('d-none');
        $('.transaction-table').removeClass('d-none');
    });

    $('.corporate-filter-reset-link').on('click', function () {
        $('.corporate-find-value').val("");
        $('.corporate-find-in-value').val("");
    });
});

/*
 * Accounts logic
 */
$(function () {
    // close all sub collpase component when close a account panel
    $(document).on('hidden.bs.collapse', '.account .collapse-under-btn', function (e) {
        if (!$(this).is(e.target)) return;
        $(this).find('.collapse.show').hide();
    });

    // Capture show event
    $(document).on('shown.bs.collapse', '.transaction-table .hidden-row .collapse', function () {
        var elem = $(this).find('.transaction-details-table');
        if (elem.length > 0) {
            var tableWidth = elem.width();
            var panelWidth = $(this).parents('.transaction-table').parent().width();
            if (tableWidth > panelWidth) {
                $(this).find('.transaction-details').css({
                    'width': panelWidth,
                    'overflow-x': 'auto'
                });
            } else {
                $(this).find('.transaction-details').attr('style');
            }
        }
    });

    $('#welcome_message .close-icon').on('click', function () {
        $('.welcome-message').addClass('d-none');
        $(this).parents('.homepage').removeClass('has-welcome-message');
    });

    let $welcomeMessage = $('.homepage .welcome-message');
    if ($welcomeMessage.length > 0) {
        $welcomeMessage.parents('.homepage').addClass('has-welcome-message');
    }
});

/*
 * Transactions
 */
$(function () {
    //add class to quicklinks button group when more option list expanded
    $(document).on('show.bs.collapse', '.accounts-overview .stand-alone > .collapse', function (e) {
        if (!$(this).is(e.target)) return;

        $('.stand-alone .btn-group.d-flex').addClass('more-option-expanded');
    });

    $(document).on('hidden.bs.collapse', '.accounts-overview .stand-alone > .collapse', function (e) {
        if (!$(this).is(e.target)) return;

        $('.stand-alone .btn-group.d-flex').removeClass('more-option-expanded');
    });
});

/*
 * Transfer Money page
 */
$(function () {
    //get To accounts details information when click list item on Account list with serach input panel
    $(document).on('click.allAccountList', '.payees-with-search-panel a[data-key]', function () {
        var key = $(this).data('key');
        if (key && typeof (getToDetails) !== 'undefined') {
            /* global getToDetails */
            getToDetails(key);
        }
    });

    //show relative tab when click My Account list item
    $(document).on('click.myAccountList', '.payees-with-search-panel .payees-myaccount a.list-group-item', function () {
        //update validator
        $(this).parent().on('shown.bs.tab', function () {
            $('form').validator('update');
        });

        $('#myaccount_transfer_container').removeClass('d-none');
        $('#osko_transfer_container').addClass('d-none');
        $(".transfer-newpayee-container").addClass('d-none');

        $('.transfer-buttons-container').removeClass('d-none');
    });

    //External Accounts list handler
    $(document).on('click.externalAccountList', '.payees-with-search-panel .payees-external-accounts .list-group-item', function () {
        $('.transfer-buttons-container').removeClass('d-none');
        $('#osko_transfer_container').removeClass('d-none');
        $(".transfer-newpayee-container").addClass('d-none');
        $('#myaccount_transfer_container').addClass('d-none');
    });

    //New Payee button Handler
    $(document).on('click.newPayeeBtn', '.payees-with-search-panel .new-payee-btn', function () {
        Common.searchPanelBtnClick(this, 'Add New Payee');
        $(".transfer-newpayee-container").removeClass('d-none');
        $('#myaccount_transfer_container').addClass('d-none');
        $('#osko_transfer_container').addClass('d-none');
    });

    //process new payee's fields change event, it will show transfer form fileds
    $('.newpayee-transfer-details-trigger').change(function () {
        //show hidden tranfer form fields
        $('.new-payee-transfer-details').removeClass('d-none');
        $('.transfer-buttons-container').removeClass('d-none');

        //update validator
        $('form').validator('update');
    });

    //New payee Financial Account radio checked event
    $(document).on('click.transfer-to-curr-bank-radio-yes', '.transfer-to-curr-bank-radio-yes', function () {
        $('.new-payee-transfer-details').removeClass('d-none');
        $('.transfer-buttons-container').removeClass('d-none');
        var elem = $('.transfer-to-curr-bank-radio-yes input')[0];
        if (elem.onclick) {
            elem.onclick.apply(elem);
        }
    });
    $(document).on('click.transfer-to-curr-bank-radio-no', '.transfer-to-curr-bank-radio-no', function () {
        var bsbField = $('#payee_financial_radio_no_tab .newpayee-transfer-details-trigger').val();
        if (!bsbField) {
            $('.new-payee-transfer-details').addClass('d-none');
        }
        var elem = $('.transfer-to-curr-bank-radio-no input')[0];
        if (elem.onclick) {
            elem.onclick.apply(elem);
        }
    });

    $(document).on('hidden.bs.collapse', '.payees-with-search-panel', function (e) {
        if (!$(this).is(e.target)) return;
        $('.payees-with-search-panel .list-group-item').removeClass('active');
    });

    $(document).on('click.newpayee_list_tab_mobile', '#newpayee_list_tab_mobile .list-group-item', function () {
        var target = $(this).attr('href');
        $('.transfer-type-btn-group label[data-bs-target="' + target + '"]').trigger('click');
    });

    function selectTransMethodMobile(text, href) {
        var panelTitleEle = $('#newpayee_list_tab_mobile').parent('.panel-selectlist').find('.panel-title');
        panelTitleEle.text(text);
        if (href) {
            var $listItem = $('#newpayee_list_tab_mobile').find(`[href='${href}']`);
            $('#newpayee_list_tab_mobile .list-group-item').removeClass('active');
            $listItem.addClass('active');
        }
    }

    function setTransMethodMobile() {
        var elements = $('.transfer-type-btn-group > label > input[type="radio"]');
        elements.each(function () {
            if ($(this).prop('checked')) {
                var $parent = $(this).parent('label');
                var text = $parent.text();
                var href = $parent.data('bs-target');
                selectTransMethodMobile(text, href);
            }
        });
    }

    setTransMethodMobile();

    $(document).on('click.newpayee-radio-click', '.transfer-type-btn-group > label', function () {
        var text = $(this).text();
        var href = $(this).data('bs-target');
        selectTransMethodMobile(text, href);
    });

    // Transfer Money without NPP
    $(document).on('click', '.transfer-money-without-npp .payees-with-search-panel .payees-external-accounts .list-group-item', function () {
        $(".transfer-details-container").removeClass('d-none');
    });

    $(document).on('click', '.transfer-money-without-npp .payees-with-search-panel .new-payee-btn', function () {
        $(".transfer-details-container").removeClass('d-none');
        $(".transfer-buttons-container").removeClass('d-none');
    });
});



/*
 * Manage PayID
 */
$(function () {
    $('#manage_payid_details_select_listgroup a[data-bs-toggle="tab"]').on('show.bs.tab', function () {
        $('.manage-payid-details-global-cancel-btn').addClass('d-none');
    });
});

/* Update Contact Details */
$(function () {
    if ($('.update-contact-inserted-rows-container .contact-info-insert-row:not(.d-none)').length === 0) {
        $('.update-contact-details-desc-placeholder').hide();
        $('.update-contact-details-desc-placeholder').parents('.tab-pane').addClass('desc-placeholder-hidden');
    }

    $('.update-contact-add-contact-btn').click(function () {
        $('.update-contact-inserted-rows-container .contact-info-insert-row.contact-info-insert-row-template').clone()
            .appendTo('.update-contact-inserted-rows-container').removeClass('contact-info-insert-row-template');
    });

    $(document).on('click', '.update-contacts-remove-inserted-row-btn', function () {
        $('.update-contact-add-contact-btn').prop('disabled', false);

        $(this).parents('.contact-info-insert-row').remove();
    });

    $('.update-contact-add-email-btn').click(function () {
        $('.update-contact-inserted-email-rows-container .contact-info-insert-row.contact-info-insert-row-template').clone()
            .appendTo('.update-contact-inserted-email-rows-container').removeClass('contact-info-insert-row-template');
    });

    $('.update-contact-add-profile-btn').click(function () {
        $('.update-contact-inserted-profile-rows-container .contact-info-insert-row.contact-info-insert-row-template').clone()
            .appendTo('.update-contact-inserted-profile-rows-container').removeClass('contact-info-insert-row-template');
    });

    $(document).on('click', '.swticher-group-parent .switcher-btns .btn:first-child', function () {
        var btns = $(this).parents('.swticher-group-parent').find('.switcher-btns .btn:last-child');

        btns.each(function () {
            if (!$(this).hasClass('active')) {
                $(this).parents('.btn-group').find('.btn').removeClass('active');
                $(this).addClass('active');
                $(this).children('input').prop('checked', true);
            }
        });
    });


    $(document).on('change', '.contact-info-select', function () {
        $(this).attr('readonly', 'readonly');
    });

    function hiddenPayidBtn() {
        var payidContainers = $('.update-contact-details-payid-btn-container button');
        if (payidContainers && payidContainers.length === 0) {
            $('.update-contact-details-payid-btn-container').addClass('d-none');
        } else {
            if ($(window).width() < 768 && $('.contact-info-insert-row .update-contact-details-payid-btn-container button').length === 0) {
                $('.contact-info-insert-row .update-contact-details-payid-btn-container').addClass('d-none');
            } else {
                $('.contact-info-insert-row .update-contact-details-payid-btn-container').removeClass('d-none');
            }
        }
    }
    hiddenPayidBtn();
    $(window).resize(hiddenPayidBtn);
});

/* BPAY */
$(function () {
    $(document).on('click.bpayBillerList', '.bpay-biller-list .list-group-item', function () {
        $('.bpay-transfer-details').removeClass('d-none');
        $('.bpay-add-new-biller').addClass('d-none');
        $('.bpay-new-billers-list').addClass('d-none');

        //Populate CRN field
        var crn = $(this).data('ref');

        $('.bpay-biller-crn').val(crn);
    });

    $(document).on('click.bpayNewBillerBtn', '.bpay-new-biller-btn', function () {
        Common.searchPanelBtnClick(this, 'Pay New Biller');
        $('.bpay-add-new-biller').removeClass('d-none');
        $('.bpay-transfer-details').removeClass('d-none');
        $('.bpay-biller-crn').val('');
    });

    $(document).on('click.btnSearchBiller', '.btn-search-biller', function () {
        //Load search result data
        window.MvpFE.loadBpayBillersSearchResult();
        $('.search-input-with-btn-container').addClass('search-list-open');

        $('.new-biller-search-input').val('');
    });

    $(document).on('focus.newBillerSearchInput', '.new-biller-search-input', function () {
        if (!window.dataNewBillers) {
            return;
        }

        window.MvpFE.loadBpayBillersSearchResult();
        $('.bpay-new-billers-list').removeClass('d-none');
        $('.search-input-with-btn-container').addClass('search-list-open');
    });

    $(document).on('click.bpayNewBillers', '.bpay-new-billers-list .list-group-item', function () {
        $('.new-biller-search-input').val('');
        $('.bpay-new-billers-list').addClass('d-none');
        $('.search-input-with-btn-container').removeClass('search-list-open');
        $('.bpay-new-biller-info-container').removeClass('d-none');
        //reload data
        TmplData.setTemplateData('template_new_billers', TmplData.dataNewBillersFormated, '.bpay-new-billers-list');

        //Populate new biller fields
        var code = $(this).data('code');
        var name = $(this).data('name');

        $('.bpay-new-biller-code').val(code);
        $('.bpay-new-biller-name').text(name);
    });

    // Bpay view biller
    $(document).on('click', '.bpay-new-billers-list .list-group-item', function () {
        $('.bpay-view-billers-register-required-content').removeClass('d-none');
    });
});

/* SMS Banking Options */
$(function () {
    $(document).on('click', '.sms-banking-options-add-mobile', function () {
        $(this).addClass('d-none');
        $('.sms-banking-options-hidden-mobile').removeClass('d-none');
    });
});

/* Term Deposit Maintenance */
$(function () {
    var okBtnStatus = {
        cheque: false,
        credit: false,
        reinvest: false,
        transfer: false
    };

    function clearHiddenFields() {
        $('[data-clear]').val('');
    }

    function updateOkBtnStatus(show) {
        if (show) {
            $('.term-deposit-maintenance-btn-ok').removeClass('d-none');
        } else {
            $('.term-deposit-maintenance-btn-ok').addClass('d-none');
        }
    }
    $(document).on('shown.bs.tab', '#term_deposit_maintenance_payments_list a[data-bs-toggle="tab"]', function (e) {
        if ($(e.target).attr('href') == '#term_deposit_cheque_tab') {
            updateOkBtnStatus(okBtnStatus.cheque);
        } else if ($(e.target).attr('href') == '#term_deposit_credit_external_tab') {
            updateOkBtnStatus(okBtnStatus.credit);
        } else if ($(e.target).attr('href') == '#term_deposit_reinvest_tab') {
            updateOkBtnStatus(okBtnStatus.reinvest);
        } else if ($(e.target).attr('href') == '#term_deposit_transfer_tab') {
            updateOkBtnStatus(okBtnStatus.transfer);
        }
    });

    $(document).on('shown.bs.tab', '#term_deposit_maintenance_payments_list a[href="#term_deposit_reinvest_tab"]', function () {
        $('.term-deposit-maintenance-btn-ok').removeClass('d-none');
        okBtnStatus.reinvest = true;
    });

    function showCommonFieldInChequeTab() {
        $('.term-deposit-maintenance-cheque-payee-details').removeClass('d-none');
        $('.term-deposit-maintenance-btn-ok').removeClass('d-none');
        $('.term-deposit-maintenance-cheque-institution-payee-fields').addClass('d-none');
        okBtnStatus.cheque = true;
    }

    $(document).on('click', '.term-deposit-cheque-new-payee-btn', function () {
        clearHiddenFields();
        Common.searchPanelBtnClick(this, 'Add new Payee');
        $('.term-deposit-maintenance-heading-new-payee').removeClass('d-none');
        $('.term-deposit-maintenance-heading-payee-details').addClass('d-none');

        // clear filelds
        $('.term-deposit-maintenance-cheque-payee-nickname-input').val($(this).data(''));
        $('.term-deposit-maintenance-cheque-payee-ref-input').val($(this).data(''));

        showCommonFieldInChequeTab();
    });

    $(document).on('click', '.term-deposit-cheque-to-payee-list .list-group-item', function () {
        clearHiddenFields();
        $('.term-deposit-maintenance-heading-new-payee').addClass('d-none');
        $('.term-deposit-maintenance-heading-payee-details').removeClass('d-none');
        showCommonFieldInChequeTab();

        // fill filelds
        $('.term-deposit-maintenance-cheque-payee-nickname-input').val($(this).data('nickname'));
        $('.term-deposit-maintenance-cheque-payee-ref-input').val($(this).data('ref'));
    });

    $(document).on('click', '.term-deposit-cheque-institution-payee-btn', function () {
        clearHiddenFields();
        Common.searchPanelBtnClick(this, 'Add Institution Payee');
        $('.term-deposit-maintenance-btn-ok').removeClass('d-none');
        $('.term-deposit-maintenance-cheque-institution-payee-fields').removeClass('d-none');
        $('.term-deposit-maintenance-heading-new-payee').addClass('d-none');
        $('.term-deposit-maintenance-heading-payee-details').addClass('d-none');
        $('.term-deposit-maintenance-cheque-payee-details').addClass('d-none');
        okBtnStatus.cheque = true;
    });

    $(document).on('click', '.term-deposit-credit-new-payee-btn', function () {
        clearHiddenFields();
        Common.searchPanelBtnClick(this, 'Add new Payee');
        $('.term-deposit-maintenance-credit-new-payee-fields').removeClass('d-none');
        $('.term-deposit-maintenance-credit-reference-field').removeClass('d-none');
        $('.term-deposit-maintenance-btn-ok').removeClass('d-none');
        okBtnStatus.credit = true;
    });

    $(document).on('click', '.term-deposit-maintenance .common-external-payee-list .list-group-item', function () {
        clearHiddenFields();
        $('.term-deposit-maintenance-credit-new-payee-fields').addClass('d-none');
        $('.term-deposit-maintenance-credit-reference-field').removeClass('d-none');
        $('.term-deposit-maintenance-btn-ok').removeClass('d-none');
        okBtnStatus.credit = true;
    })

    $(document).on('click', '.term-deposit-maintenance .new-payee-btn', function () {
        clearHiddenFields();
        $('.term-deposit-maintenance-transfer-new-payee-fields').removeClass('d-none');
        $('.term-deposit-maintenance-transfer-reference-field').removeClass('d-none');
        $('.term-deposit-maintenance-btn-ok').removeClass('d-none');
        okBtnStatus.transfer = true;
    });

    $(document).on('click', '.term-deposit-maintenance .payees-myaccount, .term-deposit-maintenance .payees-external-accounts', function () {
        clearHiddenFields();
        $('.term-deposit-maintenance-transfer-new-payee-fields').addClass('d-none');
        $('.term-deposit-maintenance-transfer-reference-field').removeClass('d-none');
        $('.term-deposit-maintenance-btn-ok').removeClass('d-none');
        okBtnStatus.transfer = true;
    });

    $(document).on('change', '.term-deposit-term-options', function () {
        let termValue = $(this).val();
        if (termValue) {
            termValue = termValue.charAt(0).toUpperCase() + termValue.slice(1);
            $(this).parents('.row').find('.term-deposit-term-value').text(termValue);
        }
    });

    $(document).on('change', '.term-deposit-term-options-btn-group input', function () {
        let termValue = $(this).val();
        if (termValue) {
            termValue = termValue.charAt(0).toUpperCase() + termValue.slice(1);
            $(this).parents('.row').find('.term-deposit-term-value').text(termValue);
        }
    });
});

/* Statements */
$(function () {
    // Hidden or show every account list item feature according to All Accounts switcher, this feature may be used on other pages
    $('.account-list-all-accounts-switcher .label-yes, .account-list-all-accounts-switcher .label-no').click(function () {
        var listGroup = $(this).parents('.list-group');

        if (listGroup.length > 0) {
            var childrenItems = listGroup.children('.list-group-item:not(.account-list-all-account-item)');
            if ($(this).hasClass('label-yes')) {
                childrenItems.addClass('d-none');
            } else if ($(this).hasClass('label-no')) {
                childrenItems.removeClass('d-none');
            }
        }
    });

    $(document).on('change', '.statements-select-checkbox', function () {
        let $allCheckBoxes = $('.statements-select-checkbox');
        if ($allCheckBoxes.length > 0) {
            let hasSelected = false;
            let selectedItems = 0;
            $allCheckBoxes.each(function () {
                if (this.checked) {
                    hasSelected = true;
                    selectedItems++;
                }
            });

            if (hasSelected) {
                $('.statements-email-selected-btn').removeClass('d-none');
            } else {
                $('.statements-email-selected-btn').addClass('d-none');
            }
            $('.statements-online-selected-amount').text(selectedItems);
        }
    });
});

/* New Savings Account */
$(function () {
    window.MvpFE.newCusSwapSteps = function (activeStep) {
        //acitveStep only can be 1 or 2 now
        if (activeStep == 1) {
            $('.new-savings-account-new-customer-step1').removeClass('d-none');
            $('.new-savings-account-new-customer-step2').addClass('d-none');
        } else if (activeStep == 2) {
            $('.new-savings-account-new-customer-step2').removeClass('d-none');
            $('.new-savings-account-new-customer-step1').addClass('d-none');
        }
    }
});

/* Statement Options */
$(function () {
    // account base
    // Hide Online Notification Type radios according to Statements Preerence radios' checked status
    $(document).on('click', '.statement-options-account-base-preference .text-mail, .statement-options-account-base-preference .text-none', function () {
        $(this).parents('.list-group-item').find('.statement-options-account-base-online-type').addClass('d-none');
    });

    // Show Online Notification Type radios according to Statements Preerence radios' checked status
    $(document).on('click', '.statement-options-account-base-preference .text-online, .statement-options-account-base-preference .text-both', function () {
        $(this).parents('.list-group-item').find('.statement-options-account-base-online-type').removeClass('d-none');
    });

    $(document).on('click', '.statement-options-client-base-receive-method .text-mail', function () {
        $('.statement-options-client-base-online-method').addClass('d-none');
    });

    $(document).on('click', '.statement-options-account-base-preference .text-mail, .statement-options-account-base-preference .text-online, .statement-options-account-base-preference .text-both', function () {
        $(this).parents('.list-group-item').find('.statement-options-statement-frequency').removeClass('d-none');
    });

    $(document).on('click', '.statement-options-account-base-preference .text-none', function () {
        $(this).parents('.list-group-item').find('.statement-options-statement-frequency').addClass('d-none');
    });

    $(document).on('click', '.statement-options-statement-frequency .text-days, .statement-options-statement-frequency .text-months', function () {
        $(this).parents('.statement-options-statement-frequency').find('.frequency-input-box').removeClass('d-none');
        $(this).parents('.statement-options-statement-frequency').find('.starting-on-box').removeClass('d-none');
    })

    $(document).on('click', '.statement-options-statement-frequency .text-last-day', function () {
        $(this).parents('.statement-options-statement-frequency').find('.frequency-input-box').addClass('d-none');
        $(this).parents('.statement-options-statement-frequency').find('.starting-on-box').addClass('d-none');
    })

    //client base
    $(document).on('click', '.statement-options-client-base-receive-method .text-online, .statement-options-client-base-receive-method .text-both', function () {
        $('.statement-options-client-base-online-method').removeClass('d-none');
    });

    $(document).on('click', '.statement-options-client-base-receive-method .btn-group > .btn', function () {
        $('.statement-options-statement-frequency').removeClass('d-none');
    });

    $(document).on('click', '.statement-options-client-base-online-method .statement-options-email-box .label-yes', function () {
        $('.statement-options-email').removeClass('d-none');
    });

    $(document).on('click', '.statement-options-client-base-online-method .statement-options-email-box .label-no', function () {
        $('.statement-options-email').addClass('d-none');
    });
});

/* Institution Payee Search - this can be used to more than one page */
$(function () {
    $(document).on('click', '.btn-search-institution-payee', function () {
        //Load search result data
        window.MvpFE.loadInstitutionPayee();
        $('.search-input-with-btn-container').addClass('search-list-open');
    });

    $(document).on('focus', '.institution-search-input', function () {
        if (!window.dataInstitutionPayee) {
            return;
        }

        window.MvpFE.loadInstitutionPayee();
        $('.institution-payee-list').removeClass('d-none');
        $('.search-input-with-btn-container').addClass('search-list-open');
    });

    $(document).on('click', '.institution-payee-list .list-group-item', function () {
        $('.institution-search-input').val('');
        $('.institution-payee-list').addClass('d-none');
        $('.institution-payee-name-filed').removeClass('d-none');
        $('.search-input-with-btn-container').removeClass('search-list-open');
        $('.institution-payee-name-filed input').val($(this).data('name'));
        $('.institution-payee-key-filed').val($(this).data('key'));
    });
});

// Campaign
$(function () {
    var elem = $('.campaign-content');

    if (elem && elem.length > 0) {
        $('body').addClass('campaign');
    }
});

/**
 * Login page
 */
$(function () {
    // move login-logout class to body
    var elem = $('.login-logout');
    if (elem && elem.length > 0) {
        $('body').addClass('login-logout');
        elem.removeClass('login-logout');
    }

    function adjustOverlaySize() {
        if ($('body').height() > window.innerHeight) {
            var overlayWidth = ($(window).width() - $('.login-logout-main .main-content .row').width()) / 2;
            $('.login-logout-main-overlay-box-left, .login-logout-main-overlay-box-right').width(overlayWidth);
        } else {
            $('.login-logout-main-overlay-box-left, .login-logout-main-overlay-box-right').attr('style', '');
        }
    }

    if ($(window).width() >= 768 && $('.login-logout').length > 0) {
        adjustOverlaySize();
        //observing .login-rightobx's dom change
        var observer = new MutationObserver(function () {
            adjustOverlaySize();
        });

        var target = $('.login-rightbox');
        if (target.length > 0) {
            observer.observe(target[0], {
                attributes: true,
                subtree: true
            });
        }
    }
});

/**
 * Alerts
 */
$(function () {
    $(document).on('click', '.alerts-method-mobile-add-btn', function () {
        var hiddenBoxes = $('.alerts-method-mobile-additional.d-none');
        if (hiddenBoxes.length > 0) {
            $(hiddenBoxes[0]).removeClass('d-none');
            if ($('.alerts-method-mobile-additional.d-none').length === 0) {
                $(this).parents('.alerts-method-mobile-add-btn-box').addClass('d-none');
            }
        }
    });

    $(document).on('click', '.alerts-method-mobile-remove-btn', function () {
        $(this).parents('.alerts-method-mobile-additional').addClass('d-none');
        $('.alerts-method-mobile-add-btn-box').removeClass('d-none');
    });

    $(document).on('change', '.alerts-method-mobile-select-default', function () {
        $('.alerts-method-mobile-add-btn-box').removeClass('d-none');
    });
});

/**
 * SMS
 */
$(function () {
    $(document).on('click', '.btn-get-sms', function () {
        $('.sms-sent-message').removeClass('d-none');
    });
});

/**
 * Secure Messages
 */
$(function () {
    function hasChecked(container) {
        var elements = container.find('.checkbox-cus input[type="checkbox"]');

        for (var i = 0; i < elements.length; i++) {
            if (elements[i].checked) {
                return true;
            }
        }

        return false;
    }

    $(document).on('click', '.secure-messages-select-all-btn', function () {
        $(this).parents('.tab-pane').find('table thead .checkbox-cus input[type="checkbox"]').trigger('click');
    });

    $(document).on('change', '.secure-messages table .checkbox-cus input[type="checkbox"]', function () {
        if (this.checked || hasChecked($(this).parents('tbody'))) {
            $(this).parents('.tab-pane').find('.secure-messages-delete-selected-btn').removeClass('d-none');
        } else {
            $(this).parents('.tab-pane').find('.secure-messages-delete-selected-btn').addClass('d-none');
        }
    });

    $(document).on('click', '.secure-messages-edit-btn', function () {
        $(this).addClass('d-none');
        $(this).parents('.tab-pane').find('.secure-messages-select-all-btn').removeClass('d-none');
        $(this).parents('.tab-pane').find('tbody .checkbox-cus input[type="checkbox"]').parents('td').removeClass('d-none');
    })

    $(document).on('change', '.secure-messages-attach-doc-row input', function () {
        var parentDiv = $(this).parent('div');
        if (parentDiv.length === 0) return;

        parentDiv.nextAll('div.d-none').removeClass('d-none');
    });
});

/* International Transfer/Payment */
$(function () {
    /* To Show Section Transfer Recipient on select of Dropdown from 'To' Menu */
    $(document).on('click', '.international-transfer-recipient .list-group-item', function () {
        $('.international-transfer-recipient-details').removeClass('d-none');
        $('.international-transfer-global-button').removeClass('d-none');
        $('.international-transfer-details').removeClass('d-none');
        if ($('.international-transfer-new-recipient, .international-transfer-pay-new-recipient-tab').is(':visible')) {
            $('.international-transfer-pay-new-recipient-tab').addClass('d-none');
            $('.international-transfer-new-recipient').addClass('d-none');
        }
    });

    $(document).on('click', '.international-transfer-new-recipient-btn', function () {
        Common.searchPanelBtnClick(this, 'Pay New Recipient');
        $('.international-transfer-new-recipient').removeClass('d-none');
        if ($('.international-transfer-global-button, .international-transfer-details, .international-transfer-recipient-details').is(':visible')) {
            $('.international-transfer-global-button').addClass('d-none');
            $('.international-transfer-details').addClass('d-none');
            $('.international-transfer-recipient-details').addClass('d-none');
        }
    });

    /*  Select Payee Details Country  */
    $(document).on('change', '.international-transfer-pay-country-select', function () {
        $('.international-transfer-pay-new-recipient-tab').removeClass('d-none');
    });

    /* To Show Transfer Details on Click of List Group of Bank Search */
    $(document).on('click', '.international-transfer-search-bank-list .list-group-item, .international-transfer-new-recipient-link', function () {
        $('.international-transfer-global-button').removeClass('d-none');
        $('.international-transfer-new-recipient-input').removeClass('d-none');
        $('.international-transfer-details').removeClass('d-none');
        $('.international-transfer-search-bank-list').addClass('d-none');
    });

    // To load Additional Details Dropdown Other options
    $(document).on('change', '.international-transfer-details-input', function () {
        var opt_selected = $(this).val();
        if (opt_selected.toLowerCase() === 'other') {
            $('.international-transfer-details-other-section').removeClass('d-none');
            $('.international-transfer-details-other-input').val('');
        } else {
            $('.international-transfer-details-other-section').addClass('d-none');
        }
    });

    // To Search IBAN International Bank List 
    var international_transfer_search_input_class = '.international-transfer-search-bank-iban-input, .international-transfer-search-bank-swift-input, .international-transfer-search-bank-name-input, .international-transfer-search-bank-city-input';
    $(document).on('focus', international_transfer_search_input_class, function () {
        if (!window.dataInternationalSearchBank) {
            return;
        }
        window.MvpFE.loadInternationalSearchBank();
        $('.international-transfer-search-bank-list').removeClass('d-none');
        $('.search-input-with-btn-container').addClass('search-list-open');
    });

    $('[data-bs-target="#bank_name_tab"]').on('shown.bs.tab', function (e) {
        var targetSelector = $(e.target).data('bs-target');
        if (!targetSelector) {
            targetSelector = $(e.target).attr('href');
        }

        if ($(targetSelector).find('.form-group.has-error').length > 0) {
            $('form').validator('validate');
            //It seems bootstrap-validator has a bug to do validate again, so add this timeout to invoke again to ignore. 
            setTimeout(function () {
                $('form').validator('validate');
            });
        }
    })

    $(document).on('click', '.btn-search-international-bank', function () {
        if ($(this).parents('#bank_name_tab').length > 0) {
            $('form').validator('validate');
        }

        //Load search result data
        window.MvpFE.loadInternationalSearchBank();
        $('.search-input-with-btn-container').addClass('search-list-open');
    });
});

/*
 * Setup Security Options
 */
$(function () {
    $('#security_options_details_select_listgroup a[data-bs-toggle="tab"]').on('show.bs.tab', function () {
        $('.security-option-details-global-request-btn').removeClass('d-none');
        $('.security-option-details-global-from-account-section').removeClass('d-none');
    });
});

/* 
 * Transfer External Account
 */
$(function () {
    $(document).on('click', '.transfer-external-account-to .list-group-item', function () {
        $('.transfer-external-account-details').removeClass('d-none');
    });
});

/*
 * International Transfer Address Book
 */
$(function () {
    $(document).on('change', '.international-transfer-address-book-manage', function () {
        $('.international-transfer-address-book-tab').removeClass('d-none');
    });
    $(document).on('click', '.international-transfer-search-bank-list .list-group-item, .international-transfer-new-recipient-link', function () {
        $('.address-book-new-global-btn').removeClass('d-none');
    });
});

/* 
 * Cheque and Deposits
 */
$(function () {
    function hideOtherPane(inputClass) {
        $(inputClass).addClass('d-none');
    }
    $(document).on('click', '.cheque-deposit-cheque-new-payee-btn', function () {
        Common.searchPanelBtnClick(this, 'Add new Payee');
        $('.cheque-deposit-order-cheque-new-payee-details').removeClass('d-none');
        $('.cheque-deposit-order-cheque-transfer-details').removeClass('d-none');
        $('.common-cheque-to-payee-global-button').removeClass('d-none');
        hideOtherPane('.cheque-deposit-institution-payee-details');
    });

    $(document).on('click', '.cheque-and-deposits .term-deposit-cheque-to-payee-list .list-group-item', function () {
        $('.cheque-deposit-order-cheque-transfer-details').removeClass('d-none');
        $('.common-cheque-to-payee-global-button').removeClass('d-none');
        hideOtherPane('.cheque-deposit-order-cheque-new-payee-details');
        hideOtherPane('.cheque-deposit-institution-payee-details');
    });

    $(document).on('click', '.cheque-and-deposits .system-cheque-book #account_panel_select_options .list-group-item', function () {
        $('.cheque-deposit-order-cheque-book-pane').removeClass('d-none');
        $('.cheque-deposit-stop-cheque-pane').removeClass('d-none');
    });

    $(document).on('click', '.cheque-and-deposits #account_panel_select_options .list-group-item', function () {
        $('.cheque-deposit-order-deposit-book-pane').removeClass('d-none');
        $('.cheque-deposit-stop-cheque-pane').removeClass('d-none');
    });

    $(document).on('click', '.cheque-deposit-institution-payee-btn', function () {
        Common.searchPanelBtnClick(this, 'Add Institution Payee');
        $('.cheque-deposit-institution-payee-details').removeClass('d-none');
        $('.cheque-deposit-order-cheque-transfer-details').removeClass('d-none');
        $('.common-cheque-to-payee-global-button').removeClass('d-none');
        hideOtherPane('.cheque-deposit-order-cheque-new-payee-details');
    });
});

// Please add new code at following with ES6 
class PageLogic {
    static pickNowRemovingData(btn) {
        if (!btn) {
            return null;
        }

        const tds = $(btn).parents('tr').children('td');
        let data = {
            removingData: []
        };
        tds.each((index, element) => {
            if ($(element).data('title') !== undefined) {
                data.removingData.push({
                    title: $(element).data('title'),
                    text: $(element).text()
                })
            }
        });

        return data;
    }

    static insertNowRemovingData(data) {
        TmplData.setTemplateData('template_notice_of_withdrawal_remove_confirm_content', data, '.notices-of-withdrawal-confirm-content');
    }

    static cancelAddingNewNow(btn) {
        $(btn).parents('tr').remove();
    }

    static businessViewpointShowBox(elem) {
        var approveChangeEle = document.getElementsByClassName('business-viewpoint-approve-change-container')[0];
        var btnUpdateAccessLevel = document.getElementsByClassName('business-viewpoint-update-access-level-btn')[0];
        var btnUpdatePassword = document.getElementsByClassName('business-viewpoint-update-password-btn')[0];
        var btnDeleteLogin = document.getElementsByClassName('business-viewpoint-delete-login-btn')[0];
        if ($(elem).attr('href') === '#tab_access_level') {
            approveChangeEle.classList.remove('d-none');
            btnUpdateAccessLevel.classList.remove('d-none');
            btnUpdatePassword.classList.add('d-none');
            btnDeleteLogin.classList.add('d-none');
        } else if ($(elem).attr('href') === '#tab_update_password') {
            approveChangeEle.classList.add('d-none');
            btnUpdateAccessLevel.classList.add('d-none');
            btnUpdatePassword.classList.remove('d-none');
            btnDeleteLogin.classList.add('d-none');
        } else if ($(elem).attr('href') === '#tab_delete_login') {
            approveChangeEle.classList.remove('d-none');
            btnUpdateAccessLevel.classList.add('d-none');
            btnUpdatePassword.classList.add('d-none');
            btnDeleteLogin.classList.remove('d-none');
        } else {
            console.error('Error: businessViewpointShowBox');
        }
    }
}

class OnlineLending {
    static applicantDetailsNavHandler(elem) {
        const siblings = $(elem).siblings();
        siblings.each((index, elemment) => {
            $($(elemment).data('bs-target')).collapse('hide');
        });
        $($(elem).data('bs-target')).collapse('show');

        const parentElement = $(elem).parents(".online-lending-applicant-pane");
        parentElement.find('.online-lending-applicant-min-max-buttons label').removeClass('active');
        parentElement.find('.online-lending-applicant-min-max-buttons input').prop('checked', false);
        setTimeout(function () {
            $('html').animate({
                scrollTop: $($(".online-lending-applicant-details-heading [data-bs-target='" + $(elem).data('bs-target') + "']")[0]).parent().offset().top
            }, 200);
        }, 400);
    }

    static onlineLendingMaximiseApplicantDetails(elem) {
        const parentElement = $(elem).closest('.online-lending-applicant-pane');
        const label = $(elem).attr('data-label');

        if (label === 'max-all') {
            parentElement.find(".online-lending-applicant-details-pane").collapse('show');
        } else {
            parentElement.find(".online-lending-applicant-details-pane").collapse('hide');
        }

        parentElement.find('.online-lending-applicant-details-nav label').removeClass('active');
        parentElement.find('.online-lending-applicant-details-nav input').prop('checked', false);
    }
}


// document ready
$(() => {
    // Notices of withdrawal - Remove
    $('#notice_of_withdrawal_remove_confirm').on('show.bs.modal', event => {
        const button = event.relatedTarget;
        const data = PageLogic.pickNowRemovingData(button);
        PageLogic.insertNowRemovingData(data);
    });

    $(document).on('click', '.notices-of-withdrawal-cancel-btn', e => {
        PageLogic.cancelAddingNewNow(e.currentTarget);
    });

    /* Bussiness Viewpoint */
    $('#business_viewpoint_modifications > a[data-bs-toggle="tab"]').on('shown.bs.tab', e => {
        PageLogic.businessViewpointShowBox(e.target);
    });

    /* Online Lending Start*/
    $(document).on('click', '.online-lending-applicant-details-nav > label', function () {
        OnlineLending.applicantDetailsNavHandler(this);
    });

    $(document).on('click', '.online-lending-applicant-details-heading > [data-bs-toggle="collapse"]', function () {
        $(this).parents('.online-lending-applicant-pane').find(`.online-lending-applicant-details-nav > [data-bs-target="${$(this).data('bs-target')}"]`).trigger('click');
        if ($(this).attr('aria-expanded') === 'false') {
            $(this).parents('.online-lending-applicant-pane').find(`.online-lending-applicant-details-nav label`).removeClass('active');
        }
    });

    $(document).on('click', '.online-lending-applicant-min-max-buttons label', function () {
        OnlineLending.onlineLendingMaximiseApplicantDetails(this);
    });

    $(document).on('keyup', '.online-lending-applicant-min-max-buttons label', function (e) {
        if (e.key === "Enter") {
            OnlineLending.onlineLendingMaximiseApplicantDetails(this);
        }
    });

    // handler credit card list active status
    $(document).on('click', '.online-lending-card-list .list-group-item', function () {
        if ($(this).hasClass('active')) return;

        $(this).siblings('.list-group-item').removeClass('active');
        $(this).addClass('active');
    });


    $(document).on('keyup', 'label[role="button"], a.list-group-item-action,.online-lending span.link-with-icon[role="button"],.btn-group label.btn', function (e) {
        if (e.key === "Enter") { // If the the enter key was pressed.
            $(this).trigger("click"); // Trigger the button(elementId) click event.
            e.preventDefault(); // Prevent the form submit if any.
        }
    });
    /* Online Lending End*/

    /* Online ID Start */
    $(document).on('click', '.online-identification-content .online-identification-content-max-min-actions .btn', function () {
        let action = $(this).data('label');
        let actionBtns = $('.online-identification-content [data-parent-cus]');
        if (action === 'max-all') {
            actionBtns.each(function () {
                let target = $(this).data('bs-target');
                $(target).collapse('show');
            });
        } else if (action === 'mini-all') {
            actionBtns.each(function () {
                let target = $(this).data('bs-target');
                $(target).collapse('hide');
            });
        } else {
            console.error('cannot recognize correct action: action is ' + action);
        }
    });

    $(document).on('click', '[data-parent-cus=".online-identification-content"]', function () {
        let radioBtns = $(this).parents('.online-identification-content').find('.online-identification-content-max-min-actions .btn');
        radioBtns.removeClass('active');
        radioBtns.children('input').prop('checked', false);
    });
    /* Online ID End */

    // Manage Cards Begin
    $('.manage-cards a[href="#send_to_address_yes"]').on('shown.bs.tab', function () {
        $('.manage-cards .card-order').removeClass('d-none');
    });
    $('.manage-cards a[href="#send_to_address_yes"]').on('hidden.bs.tab', function () {
        $('.manage-cards .card-order').addClass('d-none');
    });

    $(document).on('click', '.manage-cards .order-new-card-btn', function () {
        $('.manage-cards .order-a-new-card-box').removeClass('d-none');
        $(this).addClass('d-none');
        $('.manage-cards .card-order').removeClass('d-none');
    });

    $('.manage-cards .enter-expire-date').on('change', function () {
        $('.manage-cards .active-card-btn').removeClass('d-none');
    });

    $('.manage-cards-action-list .list-group-item').click(function () {
        $('.manage-cards-global-buttons').addClass('d-none');
    });

    $('.card-lost-stolen-buttons .btn').click(function () {
        $('.card-lost-stolen-stop').removeClass('d-none');
    });

    // we only control the UI show/hide logic here, for business logic which needs to handle in .net code
    $('.manage-cards-options-instore-au-switcher .label-yes').click(function () {
        $('.manage-cards-options-instore-au-tapgo').removeClass('d-none');
    });

    $('.manage-cards-options-instore-au-switcher .label-no').click(function () {
        $('.manage-cards-options-instore-au-tapgo').addClass('d-none');
    });

    $('.manage-cards-options-instore-intl-switcher .label-yes').click(function () {
        $('.manage-cards-options-instore-intl-tapgo').removeClass('d-none');
    });

    $('.manage-cards-options-instore-intl-switcher .label-no').click(function () {
        $('.manage-cards-options-instore-intl-tapgo').addClass('d-none');
    });
    // Manage Cards End

    //One Time Password Start
    $(document).on('click', '.get-otp-btn', function () {
        $('.otp-sent-notification-alert').removeClass('d-none');
        $('.otp-sent-sms-alert').addClass('d-none');
        $('.otp-sent-token-alert').addClass('d-none');
        $('.get-opt-password-box').removeClass('d-none');
        $('.opt-label').removeClass('d-none');
        $('.opt-label-sms').addClass('d-none');
        $('.opt-label-token').addClass('d-none');
    });

    $(document).on('click', '.get-otp-sms-btn', function () {
        $('.otp-sent-notification-alert').addClass('d-none');
        $('.otp-sent-sms-alert').removeClass('d-none');
        $('.opt-label').addClass('d-none');
        $('.opt-label-sms').removeClass('d-none');
    });

    $(document).on('click', '.get-otp-token-btn', function () {
        $('.otp-sent-notification-alert').addClass('d-none');
        $('.otp-sent-token-alert').removeClass('d-none');
        $('.opt-label').addClass('d-none');
        $('.opt-label-token').removeClass('d-none');
    });

    //One Time Password End

    // How I Spend Account Settings Start
    $(document).on('click', '.howispend-account-setting .label-yes', function () {
        if (!$('.howispend-account-setting .label-yes').hasClass('active')) {
            $('#howispend_enable_confirm_modal').modal('show');
        }
    });

    $(document).on('click', '.howispend-account-setting .label-no', function () {
        if (!$('.howispend-account-setting .label-no').hasClass('active')) {
            $('#howispend_disable_confirm_modal').modal('show');
        }
    });

    $(document).on('click', '.account-setting-howispend-no-cancel', function () {
        $('.howispend-account-setting .btn').removeClass('active');
        $('.howispend-account-setting .label-yes').addClass('active');
        $('.howispend-account-setting .label-yes input').prop('checked', true);
    });

    $(document).on('click', '.account-setting-howispend-yes-cancel', function () {
        $('.howispend-account-setting .btn').removeClass('active');
        $('.howispend-account-setting .label-no').addClass('active');
        $('.howispend-account-setting .label-no input').prop('checked', true);
    });
    //How I Spend Account Settings End

    //Card Transaction Notifications Start
    $(document).on('change', '.card-transaction-notifications .card-select-control', function () {
        let selectedIndex = $(this).find("option:selected").index();
        let selectedValue = $(this).find("option:selected").val();
        if (selectedIndex !== 0 && selectedValue !== "") {
            $(".card-transaction-notifications .card-details-container").removeClass("d-none");
        }
    });
    // Card Transaction Notifications End

    // Authenticator App One-Time Password Input Handling
    document.addEventListener("DOMContentLoaded", () => {
        document.addEventListener("input", (event) => {
            if (event.target.matches(".otp-container .otp-input")) {
                let input = event.target;
                let value = input.value;
                let inputs = document.querySelectorAll(".otp-input");
                let index = Array.from(inputs).indexOf(input);

                // Move to next input if a number is entered
                if (value.length === 1 && index < inputs.length - 1) {
                    inputs[index + 1].focus();
                }
            }
        });

        document.addEventListener("keydown", (event) => {
            if (event.target.matches(".otp-container .otp-input")) {
                let input = event.target;
                let inputs = document.querySelectorAll(".otp-input");
                let index = Array.from(inputs).indexOf(input);

                // Handle backspace to move focus back
                if (event.key === "Backspace" && input.value === "" && index > 0) {
                    inputs[index - 1].focus();
                }
            }
        });
    });

});

module.exports = PageLogic;